
document.addEventListener('DOMContentLoaded', function () {
    const fadeInObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Add the fade-in class
                entry.target.classList.add('fade-in');
                // Stop observing the element after it's faded in
                observer.unobserve(entry.target);
            }
        });
    }, {
        root: null,      // Observe in the viewport
        threshold: 0.1   // Trigger when 10% of the element is visible
    });


    document.querySelectorAll('[data-fade], .fade-trigger').forEach(element => {
        fadeInObserver.observe(element);
    });
});
